export const widgetDefault = {
  background: '#ffffff',
  text: '#000000',
  link: '#4982B8',
  action: '#4982B8',
  freeShippingBackground: '#DDEDFD',
  freeShippingText: '#004285',
}
